import { media, PrimaryButton, T2 } from 'ia-react-core';
import styled from 'styled-components';

export const StyledButton = styled(PrimaryButton)`
  width: 100%;

  ${media.sm`
    width: inherit;
    position: absolute;
    right: 33px;
    top: 36px;
  `};
`;

export const StyledT = styled(T2)`
  margin-bottom: 24px;
  ${media.sm`
    margin-bottom: 0;
    width: 80%;
  `};
`;
